module.exports = __webpack_public_path__ + "static/media/publish-videos-images-desktop-en.34bf39fc.png";